"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderListbox_unstable", {
    enumerable: true,
    get: function() {
        return renderListbox_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reactutilities = require("@fluentui/react-utilities");
const _reactaria = require("@fluentui/react-aria");
const _ListboxContext = require("../../contexts/ListboxContext");
const renderListbox_unstable = (state, contextValues)=>{
    (0, _reactutilities.assertSlots)(state);
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_reactaria.ActiveDescendantContextProvider, {
        value: contextValues.activeDescendant,
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_ListboxContext.ListboxContext.Provider, {
            value: contextValues.listbox,
            children: /*#__PURE__*/ (0, _jsxruntime.jsx)(state.root, {})
        })
    });
};
